module.exports = "/_next/static/images/3b6b7b36a4905f9b58df160dc1d41626-credit-card-perks-xs-1x.gif.webp";